import { backendMessagesAr } from './backendMessagesAr';
import { backendMessagesEs } from './backendMessagesEs';
import { backendMessagesMs } from './backendMessagesMs';
import { backendMessagesPt } from './backendMessagesPt';

/**
 * Every backend-message catalog, keyed by language. Add a language here the
 * moment you add its backendMessages<Lng> file — backendMessagesCoverage.test
 * iterates this, so registering the catalog is what holds it to covering every
 * CustomError message the backend can send. A catalog that exists but is not
 * registered here is checked by nothing.
 *
 * Keep the keys in step with LANGUAGES in frontend/src/locales/i18n.ts, which
 * loads these as the i18next 'backend' namespace.
 */
export const backendMessages: Record<string, Record<string, string>> = {
  es: backendMessagesEs,
  pt: backendMessagesPt,
  ar: backendMessagesAr,
  ms: backendMessagesMs,
};
